<template>
  <div class="iphone-activity-item3">
    <h2 class="iphone-activity-title">
      {{ element.titleBarName }}
    </h2>
    <div class="card" v-for="(item, index) in childItem.propsValue.data" :key="index">
      <h3>{{ item.customField1 }}</h3>
      <ul>
        <li v-for="(child, cindex) in item.customField2" :key="cindex">
          <img :src="child.customField5" alt="" />
          <div class="card-text">
            <h4>{{ child.customField3 }}</h4>
            <p>{{ child.customField4 }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkFuwujiazhiPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text",
        },
        {
          code: "customField2",
          label: "分组",
          type: "list",
          children: [
            {
              code: "customField3",
              label: "标题",
              type: "text",
            },
            {
              code: "customField4",
              label: "描述",
              type: "text",
            },
            {
              code: "customField5",
              label: "logo",
              type: "image",
              width: 27,
              height: 27,
            },
          ],
        },
      ],
      data: [
        {
          customField1: "企业管控 合规高效",
          customField2: [
            {
              customField3: "聚资源、融场景",
              customField4: "聚合商旅资源，全面融合员工差旅及消费场景",
              customField5: "https://mks.yybip.com/group1/M00/08/E9/CgoRC2MOuUSAJynDAAALJ7CHDT891.jpeg",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "https://mks.yybip.com/group1/M00/01/39/CgoRDGMOuXSAOiVxAAALCH66bek54.jpeg",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "https://mks.yybip.com/group1/M00/08/E9/CgoRC2MOuYeATHCzAAAJyrqP1kg13.jpeg",
            },
          ],
        },
        {
          customField1: "员工报销 简单便捷",
          customField2: [
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "https://mks.yybip.com/group1/M00/01/39/CgoRDGMOubeAGrbpAAAL6UiGeZs24.jpeg",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "https://mks.yybip.com/group1/M00/08/E9/CgoRC2MOuceAep6eAAAK1bA6mYQ27.jpeg",
            },
              {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "https://mks.yybip.com/group1/M00/01/39/CgoRDGMOufGAIeWPAAALA-7hm2Q71.jpeg",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.iphone-activity-item3 {
  background: #ccc
    url(https://www.yonyou.com/yingxiao/caiwu/feikong/m/activity/images/bg9.jpg)
    no-repeat top left;
  background-size: 100%;
  padding: 7px;
}

.iphone-activity-title {
  text-align: center;
  color: #e31924;
  line-height: 1.5;
  font-size: 20px;
  font-weight: bold;
}
.iphone-activity-item3 h2 {
  padding-bottom: 12px;
}
.iphone-activity-item3 .card {
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding-bottom: 8px;
  margin-bottom: 26px;
  border-radius: 2px;
  box-sizing: border-box;
}
.iphone-activity-item3 .card h3 {
  font-size: 18px;
  padding-left: 8px;
  line-height: 48px;
  color: #e31924;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.iphone-activity-item3 .card ul {
  margin: 15px 7px;
}
.iphone-activity-item3 .card ul li {
  display: flex;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #ffcb21;
  padding: 0 15px;
  height: 88px;
  margin-bottom: 20px;
  background-position: right top;
  background-repeat: no-repeat;
  background-size: auto 100%;
}
.iphone-activity-item3 .card ul li img {
  display: block;
  width: 25px;
  height: 25px;
  margin-right: 15px;
}
.iphone-activity-item3 .card ul li .card-text h4 {
  font-size: 16px;
  color: #141414;
  line-height: 2;
}
.iphone-activity-item3 .card ul li .card-text p {
  font-size: 14px;
  color: #6c6c6c;
}
</style>
